import styled from 'styled-components';
import { Content } from '../components/Content';
import { Description } from '../components/Description';

const Title = styled.h1`
  font-size: 16vmin;
  line-height: 1;
  font-weight: normal;
  margin: 0;
  text-shadow: ${(props) => `0 1${props.theme.unit} #000`};
  -webkit-text-stroke: ${(props) => `0.2${props.theme.unit} #000`};
`;

export const Page404 = () => {
  return (
    <Content>
      <Title>404</Title>
      <Description>Page not found !</Description>
    </Content>
  );
};
